import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { verifyEmail, resendVerification, startSession } from '../services/api';
import '../styles/AuthPage.css';

function VerifyEmailPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [resent, setResent] = useState(false);
  // React 18 mounts twice in development, which would spend the token twice.
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    (async () => {
      try {
        const data = await verifyEmail(token);
        if (data.token) {
          startSession(data.user, data.token);
          setStatus('done');
          setTimeout(() => navigate('/papers'), 1200);
        } else {
          setStatus('done');
          setMessage(data.message || 'Your email is verified. You can sign in.');
        }
      } catch (err) {
        setStatus('failed');
        setMessage(err.response?.data?.error || 'This verification link is not valid.');
      }
    })();
  }, [token, navigate]);

  const handleResend = async (e) => {
    e.preventDefault();
    await resendVerification(email.trim().toLowerCase());
    setResent(true);
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1>PaperBuddy</h1>

        {status === 'checking' && <p className="auth-subtitle">Verifying your email…</p>}

        {status === 'done' && (
          <>
            <p className="auth-subtitle">Email verified.</p>
            {message && <p className="auth-subtitle">{message}</p>}
            <Link to="/" className="auth-link">Go to sign in</Link>
          </>
        )}

        {status === 'failed' && (
          <>
            <div className="auth-error">{message}</div>
            {resent ? (
              <p className="auth-subtitle">
                If that address still needs verification, a new link is on its way.
              </p>
            ) : (
              <form onSubmit={handleResend}>
                <div className="form-group">
                  <label htmlFor="email">Send a new link</label>
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(ev) => setEmail(ev.target.value)}
                    placeholder="Enter your email"
                    autoComplete="email"
                  />
                </div>
                <button type="submit" className="auth-btn" disabled={!email.trim()}>
                  Resend verification email
                </button>
              </form>
            )}
            <div className="auth-links">
              <Link to="/" className="auth-link">Back to sign in</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default VerifyEmailPage;
